import store from '@/store';

export default {
  created() {
    this.resizeHandler();
    window.addEventListener('resize', this.resizeHandler);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler);
  },
  methods: {
    isPc() {
      let flag = true;
      const rect = document.body.getBoundingClientRect();
      if (rect.width < 992) {
        flag = false;
      }
      return flag;
    },
    resizeHandler() {
      const device = this.isPc() ? 'desktop' : 'mobile';
      store.getters.app.device = device;
    },
  },
};
